import dayjs from 'dayjs';

export const applyConfingTexts = (config) => {
  return {
    ...config,
    userOptions: {
      buttonTitles: {
        open: 'Opciones',
        close: 'Cerrar Opciones',
        tooltip: 'Ver tooltips',
        pdf: 'Descargar PDF',
        csv: 'Descargar CSV',
        img: 'Descargar PNG',
        table: 'Ver tabla',
        labels: 'Ver etiquetas',
        fullscreen: 'Pantalla Completa',
        annotator: 'Ver anotaciones',
      },
    },
    translations: {
      total: 'Total',
      average: 'Promedio',
    },
    table: {
      columnNames: {
        series: 'Series',
        value: 'Valores',
        percentage: 'Percentaje',
      },
    },
  };
};

export const buildDateRangeQueryParams = (filters) => {
  if (filters.dateRange && Array.isArray(filters.dateRange) && filters.dateRange.length === 2) {
    return {
      startDate: dayjs(filters.dateRange[0]).startOf('day').toISOString(),
      endDate: dayjs(filters.dateRange[1]).endOf('day').toISOString(),
    };
  }

  return filters;
};
